export class PayMemoSaveDto {
    id: number;
    adjustments: string;
    comments: string;
    locked: boolean;
    updatedBy: string;
}
